exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab[data-v-66c9f590] {\r\n  padding: 0 !important;\n}\n.tab-link[data-v-66c9f590] {\r\n  padding: 10px 30px;\r\n  display: block\n}\r\n", ""]);

// exports
